import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./EventFilter.css";

type EventFilterData = {
	text : string,
    location: string,
    type: string
};

interface EventFilterProps {
	initialData: EventFilterData;
	onTextValueChange: (value: string) => void;
    onTypeValueChange: (value: string) => void;
    onLocationValueChange: (value: string) => void;
}

const EventFilters: React.FC<EventFilterProps> = ({
	initialData,
	onTextValueChange,
    onTypeValueChange,
    onLocationValueChange
}) => {
    const [selectedType, setSelectedType]= useState(initialData.type);
    const [selectedText, setSelectedText]= useState(initialData.text);
    const [selectedLocation, setSelectedLocation]= useState(initialData.location);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleFilterText = (e: any) => {
        setSelectedText(e.target.value);
		onTextValueChange(e.target.value);
	};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleTypeChange = (e: any) => {
        setSelectedType(e.target.value);
		onTypeValueChange(e.target.value);
	};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleFilterLocation = (e: any) => {
        setSelectedLocation(e.target.value);
		onLocationValueChange(e.target.value);
	};
	return (
		<>
			<h2>Filter</h2>
			<Form className="form">
				<Form.Group className="mb-3">
					<Row className="mb-2">
						<Col className="col-md-12">
							<Form.Label>Event</Form.Label>
							<Form.Control
								type="search"
								id="event_filter"
								placeholder=""
								value={selectedText}
								onChange={handleFilterText}
							/>
						</Col>
					</Row>
					<Row className="mb-2">
						<Col className="col-md-12 mb-2">
							<Form.Label htmlFor="event_location">Location</Form.Label>
							<Form.Control
								type="search"
								className="form-control"
								id="event_location"
								value={selectedLocation}
								onChange={handleFilterLocation}
							/>
						</Col>
					</Row>
					<Row className="mb-2">
						<Col className="col-md-12 mb-2 event_type_container">
							<Form.Label htmlFor="event_type">Event Type</Form.Label>
							<div className="p-2">
								<Form.Check
									type="radio"
									id="all-event_type"
									name="event_type_selector"
									className="ml-1"
									label="All"
									value="all"
									onClick={handleTypeChange}
									defaultChecked={selectedType === "all"}
								/>
							</div>
							<div className="edumate py-2 px-2">
								<Form.Check
									type="radio"
									id="edumate-event-type"
									name="event_type_selector"
									className="ml-1"
									label="Edumate"
									value="edumate"
									onClick={handleTypeChange}
									defaultChecked={selectedType === "edumate"}
								/>
							</div>
							<div className="clipboard py-2 px-2">
								<Form.Check
									type="radio"
									id="clipboard-event-type"
									name="event_type_selector"
									label="Clipboard"
									value="clipboard"
									onClick={handleTypeChange}
									defaultChecked={selectedType === "clipboard"}
								/>
							</div>
							{/* My Pymble was unreachable: every source was fetched and only
							    the three above could be picked, so events made in
							    event-manager showed up solely under "All". Edval timetable
							    bookings get no radio on purpose — see CATEGORIES_FOR_TYPE in
							    Home.tsx. */}
							<div className="py-2 px-2">
								<Form.Check
									type="radio"
									id="manual-event-type"
									name="event_type_selector"
									label="My Pymble"
									value="manual"
									onClick={handleTypeChange}
									defaultChecked={selectedType === "manual"}
								/>
							</div>
						</Col>
					</Row>
				</Form.Group>
			</Form>
		</>
	);
};

export default EventFilters;
